<template>
  <v-container class="d-flex flex-column" fluid>
    <!-- Dashboard Header Section -->
    <v-card class="mb-6" elevation="2">
      <v-card-text class="pa-6">
        <div
          class="d-flex flex-column flex-md-row align-center justify-space-between mb-4"
        >
          <div>
            <p class="text-body-1 text-medium-emphasis mb-0">
              Select vehicles to generate QR code labels for printing
            </p>
          </div>
          <div class="text-center text-md-right">
            <div class="text-h6 font-weight-medium text-primary">
              {{ selectedCount }} Selected
            </div>
            <div class="text-caption text-medium-emphasis">Ready to print</div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex flex-column flex-md-row gap-4 align-center">
          <v-btn
            @click="handlePrint"
            :loading="isLoading"
            :disabled="selectedCount === 0"
            color="primary"
            size="large"
            prepend-icon="mdi-printer"
            class="px-8"
            data-testid="generate-qr-codes-btn"
          >
            Generate QR Codes
          </v-btn>

          <v-btn
            v-if="selectedCount > 0"
            @click="clearSelection"
            variant="outlined"
            color="secondary"
            prepend-icon="mdi-close"
            data-testid="clear-selection-btn"
          >
            Clear Selection
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <!-- External Component Slot -->
    <slot name="inventory-interface"></slot>
  </v-container>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'

// Props to receive from parent
const props = defineProps<{
  selectedVehicles?: any[]
}>()

// Emits
const emit = defineEmits<{
  print: [vehicles: any[]]
  selectionChange: [vehicles: any[]]
  clearSelection: []
}>()

// Local state
const selectedCount = ref(0)
const isLoading = ref(false)

// Computed
const hasSelection = computed(() => selectedCount.value > 0)

// Methods
const handlePrint = async () => {
  if (props.selectedVehicles && props.selectedVehicles.length > 0) {
    isLoading.value = true
    try {
      await emit('print', props.selectedVehicles)
    } finally {
      isLoading.value = false
    }
  }
}

const clearSelection = () => {
  selectedCount.value = 0
  // Emit event to clear selection in external component
  emit('clearSelection')
}

// Watch for props changes
watch(
  () => props.selectedVehicles,
  newVehicles => {
    if (newVehicles) {
      selectedCount.value = newVehicles.length
    } else {
      selectedCount.value = 0
    }
  },
  { immediate: true },
)
</script>

<style scoped>
.gap-4 {
  gap: 16px;
}
</style>
